import { transformToCamelCase } from 'src/components/pageMeta/transformToCamelCase';
import { contentDetailsList } from 'src/components/thumbnail/components/ThumbnailImage/ThumbnailImageHandler';
import { checkIfEduauraa } from 'src/utils/common';
import { DynamicObject } from 'src/utils/commonTypes';
import { ILT20_SERIES } from 'src/utils/constants/stringConstants';
import { SPORTS_ROUTE } from 'src/utils/constants/utilConstants';
import {
  getActivePartnerSubscriptions,
  getContentOwner
} from 'src/utils/contentPartnerHelper';

import { mixpanelObject } from './mixpanel';
import {
  MIXPANEL_ACTIVE_PARTNER_SUBSCRIPTION,
  MIXPANEL_AGGREGATOR_PARTNER_ID,
  MIXPANEL_AGGREGATOR_PARTNER_NAME,
  MIXPANEL_AGGREGATOR_USER_TYPE,
  MIXPANEL_CAROUSAL_NAME,
  MIXPANEL_CONTENT_BILLING_TYPE,
  MIXPANEL_CONTENT_OWNER,
  MIXPANEL_CONTENT_SPECIFICATION,
  MIXPANEL_CONTENT_TYPE,
  MIXPANEL_EXTERNAL_LINK,
  MIXPANEL_HORIZONTAL_INDEX,
  MIXPANEL_IMAGE_URL,
  MIXPANEL_IS_EDUAURAA,
  MIXPANEL_IS_LIVE,
  MIXPANEL_IS_RECOMMENDED,
  MIXPANEL_IS_RENTAL,
  MIXPANEL_IS_TALAMOOS,
  MIXPANEL_MODEL_NAME,
  MIXPANEL_MODEL_ORIGIN,
  MIXPANEL_NOT_SUBSCRIBED,
  MIXPANEL_PAGE_NAME,
  MIXPANEL_RAIL_CONTENT_LISTING,
  MIXPANEL_SERIES,
  MIXPANEL_SOURCE,
  MIXPANEL_SPORTS_ILT20,
  MIXPANEL_SUBSCRIBED,
  MIXPANEL_TAB_NAME,
  MIXPANEL_TALAMOOS_CLICKID,
  MIXPANEL_TALAMOOS_MODELNAME,
  MIXPANEL_TALAMOOS_ORIGIN,
  MIXPANEL_TOP_CATEGORY,
  MIXPANEL_VERTICAL_INDEX
} from './mixpanelConstants';
import {
  contentBillingType,
  thumbnailClickEvent
} from './mixpanelEventsHelper';
import { getPageName } from '../pageName';

interface THUMBNAIL_INTERFACE {
  tabName?: string;
  talamoosModelName?: string;
  item?: any;
}

export const isSportsEvent = (path: string) =>
  path && path.includes(SPORTS_ROUTE);

export const thumbnailPropertySetter = ({
  tabName,
  talamoosModelName,
  item
}: THUMBNAIL_INTERFACE) => {
  const {
    title,
    originalTitle,
    imageUrl,
    assetSubType,
    businessType,
    billingType,
    content_partner_details,
    contentPartner,
    isSearchLanding,
    cardDetails
  } = item;
  const pageName = getPageName(window.location.pathname);
  mixpanelObject[MIXPANEL_TAB_NAME] =
    tabName ||
    (pageName &&
      (pageName.includes('landing') ||
      pageName.includes('home') ||
      pageName.includes('premium') ||
      pageName.includes('ILT20')
        ? pageName
        : 'N/A'));
  mixpanelObject[MIXPANEL_TOP_CATEGORY] = 'N/A';
  mixpanelObject[MIXPANEL_CONTENT_SPECIFICATION] = 'N/A';
  mixpanelObject[MIXPANEL_SERIES] = 'N/A';
  mixpanelObject[MIXPANEL_IS_LIVE] = 'N/A';
  mixpanelObject[MIXPANEL_TALAMOOS_MODELNAME] = 'N/A';
  mixpanelObject[MIXPANEL_IS_TALAMOOS] = false;
  mixpanelObject[MIXPANEL_TALAMOOS_MODELNAME] = 'N/A';
  mixpanelObject[MIXPANEL_TALAMOOS_ORIGIN] = 'N/A';
  mixpanelObject[MIXPANEL_TALAMOOS_CLICKID] = 'N/A';
  if (assetSubType && assetSubType.toLowerCase() === 'reco') {
    mixpanelObject[MIXPANEL_IS_TALAMOOS] = true;
    mixpanelObject[MIXPANEL_TALAMOOS_MODELNAME] = talamoosModelName || 'N/A';
    mixpanelObject[MIXPANEL_MODEL_NAME] = talamoosModelName || 'N/A';
    mixpanelObject[MIXPANEL_MODEL_ORIGIN] =
      `${pageName}_${title || originalTitle}` || 'N/A';
    mixpanelObject[MIXPANEL_TALAMOOS_ORIGIN] = item?.origin || 'N/A';
    mixpanelObject[MIXPANEL_TALAMOOS_CLICKID] = item?.clickID || 'N/A';
    mixpanelObject[MIXPANEL_IS_RECOMMENDED] = true;
  } else {
    mixpanelObject[MIXPANEL_MODEL_NAME] = 'N/A';
    mixpanelObject[MIXPANEL_MODEL_ORIGIN] = 'N/A';
    mixpanelObject[MIXPANEL_IS_RECOMMENDED] = false;
  }
  mixpanelObject[MIXPANEL_EXTERNAL_LINK] =
    item?.permalink || item?.link || 'N/A';
  mixpanelObject[MIXPANEL_IMAGE_URL] = imageUrl || 'N/A';
  if (typeof item === 'object') {
    mixpanelObject[MIXPANEL_CONTENT_TYPE] = businessType || 'N/A';
    mixpanelObject[MIXPANEL_CONTENT_BILLING_TYPE] = billingType || 'N/A';
  }
  mixpanelObject[MIXPANEL_IS_EDUAURAA] = item && checkIfEduauraa(item);
  if (contentBillingType(businessType, billingType) === 'tvod') {
    mixpanelObject[MIXPANEL_IS_RENTAL] = true;
  }
  if (
    isSportsEvent(window.location.pathname) ||
    assetSubType === 'live_event' ||
    assetSubType === 'sports_vod'
  ) {
    mixpanelObject[MIXPANEL_TOP_CATEGORY] = MIXPANEL_SPORTS_ILT20;
    mixpanelObject[MIXPANEL_CONTENT_SPECIFICATION] = MIXPANEL_SPORTS_ILT20;
    // event properties are to be added
    mixpanelObject[MIXPANEL_SERIES] = ILT20_SERIES;
    mixpanelObject[MIXPANEL_IS_LIVE] = false;
  }
  mixpanelObject[MIXPANEL_SOURCE] = getPageName(window.location.pathname);
  mixpanelObject[MIXPANEL_PAGE_NAME] = getPageName(window.location.pathname);
  mixpanelObject[MIXPANEL_SERIES] = title;
  (mixpanelObject[MIXPANEL_CAROUSAL_NAME] = title),
    (mixpanelObject[MIXPANEL_MODEL_NAME] = item?.modelName),
    (mixpanelObject[MIXPANEL_HORIZONTAL_INDEX] = item?.horizontalIndex),
    (mixpanelObject[MIXPANEL_VERTICAL_INDEX] = item?.verticalIndex),
    (mixpanelObject[MIXPANEL_RAIL_CONTENT_LISTING] = item?.railElements);
  const contentPartnerData =
    content_partner_details ||
    transformToCamelCase(contentPartner, contentDetailsList) ||
    {};
  aggregatorPropertySetter(contentPartnerData);
  // Calling thumbnailClickEvent from mixpanel Event helper
  thumbnailClickEvent();
};

// setting partner details to mixpanel object
export const aggregatorPropertySetter = (
  contentPartnerDetails: DynamicObject
) => {
  const {
    content_partner_name: partnerName = '',
    content_partner_id: partnerId = ''
  } = contentPartnerDetails || {};
  const activePartnerSubscriptions = getActivePartnerSubscriptions();
  mixpanelObject.setProperty(
    MIXPANEL_AGGREGATOR_PARTNER_NAME,
    partnerName || 'N/A'
  );
  mixpanelObject.setProperty(
    MIXPANEL_AGGREGATOR_PARTNER_ID,
    partnerId || 'N/A'
  );
  mixpanelObject.setProperty(
    MIXPANEL_CONTENT_OWNER,
    getContentOwner(contentPartnerDetails)
  );
  mixpanelObject.setProperty(
    MIXPANEL_AGGREGATOR_USER_TYPE,
    activePartnerSubscriptions ? MIXPANEL_SUBSCRIBED : MIXPANEL_NOT_SUBSCRIBED
  );
  mixpanelObject.setProperty(
    MIXPANEL_ACTIVE_PARTNER_SUBSCRIPTION,
    activePartnerSubscriptions || 'N/A'
  );
};
